module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAbFBMVEUAAAAwcL/vYBApa73nWBgyb7w1db/qWhs4dMPnXBzmXB04csLnXRs3dMLmXRvnXBw4dMHlXBw3c8HmXBw4c8DlXR04c8HmXB3mXBzmXR3mXBw4dMHmXRw3dMDlXBzmXR3mXBzlXR3mXB3mXR13JyagAAAAI3RSTlMAEBAfIC4wMEBAUGBgcHB/gICQkJ+foKCvsL/AwM/Q3+Dv8LAkIoUAAACdSURBVBgZBcEBQoMwEADBJUVAQCSeNsZGqOz//+gMDPvSTQMAAAz32+dj6QAA4OP2u8NcLEdOAG/3nfX0iPF51QS8PEjl/Ssir3OOEaYl/ag1/upWjw2mblNbsR6GvgJNr9DQM8xA01CbWmxA06xmtViA4tHUuDS7AaPtUM+q1R6gtqZeRSMDkGpVy9O2AgBp9opvrx4AAOi3PCeAf8oiEbhpPOT0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/res/Tourney_Game_Icon.png
// module id = 1131
// module chunks = 0